<template>
    <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-66">
            <form ref="password_form" @submit.prevent="updateClient">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="card-icon">
                            <md-icon>edit</md-icon>
                        </div>
                        <h4 class="title">Modification du client</h4>
                    </md-card-header>
                    <md-card-content>
                        <div class="md-layout md-gutter">
                            <div class="md-layout-item md-size-50">
                                <md-field class="md-invalid">
                                    <label>Nom</label>
                                    <md-input v-model="client.name" required disabled type="text"></md-input>
                                </md-field>
                            </div>
                            <div class="md-layout-item md-size-50">
                                <md-field class="md-invalid">
                                    <label>Code EBP</label>
                                    <md-input v-model="client.code_ebp" required disabled type="text"></md-input>
                                </md-field>
                            </div>
						</div>
	                    <div class="md-multiselect md-multiselect-multiple mt-4">
		                    <label>Contacts</label>
		                    <multiselect v-model="selectedContact"
		                                 :options="client.contacts"
		                                 :multiple="true"
		                                 :close-on-select="false"
		                                 :show-labels="false"
		                                 label="full_name"
		                                 track-by="id"
		                                 placeholder="Contacts">
			                    <template slot="noOptions">La liste est vide</template>
			                    <template slot="noResult">Aucun élement correspondant</template>
		                    </multiselect>
	                    </div>
	                    <div class="mb-2">
		                    <md-checkbox v-model="client.is_client_area_available" disabled>Etat (si coché, l'espace client est accessible)</md-checkbox>
	                    </div>
	                    <span class="font-medium">Espace client</span>
						<div class="flex items-center space-x-4 -mt-2">
							<md-checkbox v-model="client.is_accessible_trend" class="w-auto">Afficher les tendances</md-checkbox>
							<md-checkbox v-model="client.is_accessible_audit" class="w-auto">Afficher Audits & Bilans</md-checkbox>
                        </div>
                    </md-card-content>
                    <md-card-actions md-alignment="left">
                        <md-button type="submit" class="md-success">Enregistrer</md-button>
                        <md-button class="md-warning" @click="goBack">Retour</md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "InformationsEdit",
    data() {
        return {
            client: {
				contacts: []
            },
            selectedContact: []
        }
    },
    methods: {
		async updateClient() {
			try {
				await this.$store.dispatch("clients/updateClient", {
					id: this.client.id,
					is_accessible_audit: this.client.is_accessible_audit,
					is_accessible_trend: this.client.is_accessible_trend,
					selectedContacts: this.selectedContact.map((contact) => contact.id)
				})
				await this.$store.dispatch("alerts/success","Client modifié");
				this.goBack()
			} catch (e) {
				await this.$store.dispatch("alerts/error","Une erreur est survenue");
			}
		},
        goBack() {
            this.$router.go(-1)
        },
        async getClientDetails() {
            let { data } = await this.$store.dispatch('clients/getClientDetails', this.$route.params.id)
            this.client = {
                ...data,
				is_client_area_available: !!data.is_client_area_available,
                is_accessible_trend: !!data.is_accessible_trend,
                is_accessible_audit: !!data.is_accessible_audit
            }
            this.selectedContact = data.contacts.filter(contact => { return contact.is_selected })
        }
    },
    mounted() {
        this.getClientDetails()
    }
}
</script>

<style scoped>

</style>
